import { render, staticRenderFns } from "./Suntech410.vue?vue&type=template&id=57d96825"
import script from "./Suntech410.vue?vue&type=script&lang=js"
export * from "./Suntech410.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports